/**
 * ============================================================
 * Português
 * ============================================================
 *
 * Translators:
 *
 * fsvieira <sv.filipe@gmail.com>
 */

export default {
	'AdvanceHelp': 'Pode avançar no jogo usando o botão esquerdo do rato, tocar em qualquer sitío do ecrã de jogo ou carregar na barra de espaço.',
	'AllowPlayback': 'Clique aqui para permitir a reprodução de áudio',
	'Audio': 'Áudio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Ativar reprodução automática',
	'AutoPlaySpeed': 'Velocidade de reprodução automática',

	'Back': 'Voltar',
	'BackButton': 'Voltar',

	'Cancel': 'Cancelar',
	'Close': 'Fechar',
	'Confirm': 'Deseja sair?',
	'Credits': 'Créditos',

	'Delete': 'Apagar',
	'DialogLogButton': 'Mostrar registos de diálogo',

	'FullScreen': 'Ecrã Inteiro',

	'Gallery': 'Galeria',

	'Help': 'Ajuda',
	'Hide': 'Esconder',
	'HideButton': 'Esconder caixa de texto',

	'iOSAudioWarning': 'As configurações de áudio não são suportadas no iOS',

	'KeyboardShortcuts': 'Atalhos de Teclado',

	'Language': 'Língua',
	'Load': 'Carregar',
	'LoadAutoSaveSlots': 'Jogos Salvos Automaticamente',
	'LoadButton': 'Abrir Ecrã de Carregamento',
	'Loading': 'A Carregar',
	'LoadingMessage': 'Aguarde enquanto os recursos são carregados',
	'LoadSlots': 'Jogos Salvos',
	'LocalStorageWarning': 'O armazenamento local não está disponível neste navegador',
	'Log': 'Registo',

	'Music': 'Volume de Música',

	'NewContent': 'Há novo conteúdo disponível, recarregue a página para obter a versão mais recente',
	'NoSavedGames': 'Nenhum jogo salvo',
	'NoAutoSavedGames': 'Nenhum jogo salvo automaticamente',
	'NoDialogsAvailable': 'Não há diálogos disponíveis. Os diálogos aparecerão aqui quando ocorrerem no jogo',

	'OK': 'OK',
	'OrientationWarning': 'Por favor rode o seu dispositivo para jogar',
	'Overwrite': 'Substituir',

	'QuickButtons': 'Botões de acesso rápido',
	'QuickMenu': 'Menu de acesso rápido',
	'Quit': 'Sair',
	'QuitButton': 'Sair do Jogo',

	'Resolution': 'Resolução',

	'Save': 'Salvar',
	'SaveButton': 'Abrir ecrã de salvar.',
	'SaveInSlot': 'Salvar em ranhura',
	'SelectYourLanguage': 'Select your language',
	'Settings': 'Configurações',
	'SettingsButton': 'Abrir o Ecrã de Configurações',
	'Show': 'Mostrar',
	'Skip': 'Ignorar',
	'SkipButton': 'Entrar em modo de ignorar',
	'SlotDeletion': 'Tem a certeza de que deseja eliminar este jogo?',
	'SlotOverwrite': 'Tem a certeza de que deseja substituir este jogo?',
	'Sound': 'Volume de Som',
	'Start': 'Início',
	'Stop': 'Parar',

	'TextSpeed': 'Velocidade de Texto',

	'Video': 'Video Volume',
	'Voice': 'Volume de Voz',

	'Windowed': 'Em Janela'
};